'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var _ = require('./');

exports.default = function (props) {
  var multiplier = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  var mult = function mult(value) {
    return value * multiplier;
  };

  if (typeof props === 'string') {
    if (props === 'large') return mult(_.LARGE);
    if (props === 'larger') return mult(_.LARGER);
    if (props === 'largest') return mult(_.LARGEST);
    if (props === 'small') return mult(_.SMALL);
    if (props === 'smaller') return mult(_.SMALLER);
    if (props === 'smallest') return mult(_.SMALLEST);
  }

  if ((typeof props === 'undefined' ? 'undefined' : _typeof(props)) === 'object') {
    if (props.large) return mult(_.LARGE);
    if (props.larger) return mult(_.LARGER);
    if (props.largest) return mult(_.LARGEST);
    if (props.small) return mult(_.SMALL);
    if (props.smaller) return mult(_.SMALLER);
    if (props.smallest) return mult(_.SMALLEST);
  }

  return mult(_.MEDIUM);
};